import { render, staticRenderFns } from "./art.vue?vue&type=template&id=83ae19f0&"
import script from "./art.vue?vue&type=script&lang=js&"
export * from "./art.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports